import { FC, useMemo } from 'react';
import { useLocale } from '~/stores/locale';
import { constants } from '@oresundsbron/validators';
import { DefaultLink } from './DefaultLink';
import { LinkProps } from './types';
import { useLinksV2 } from '~/hooks/useLinksV2';

const storebeltPrivacyPolicy: Record<string, string> = {
  sv: 'https://storebaelt.dk/en/privacy-policy-for-storebaelt-dk/',
  da: 'https://storebaelt.dk/privatlivspolitik-for-storebaelt-dk/',
  en: 'https://storebaelt.dk/en/privacy-policy-for-storebaelt-dk/',
};

type PrivacyPolicyLinkProps = Omit<LinkProps, 'href'> & {
  type?: string;
};

export const PrivacyPolicyLink: FC<PrivacyPolicyLinkProps> = ({
  type,
  ...rest
}) => {
  const { findLinkByCodeRef } = useLinksV2();
  const { locale } = useLocale();

  const href = useMemo(() => {
    if (type === constants.Storebelt) {
      return storebeltPrivacyPolicy[locale] ?? undefined;
    }

    const link = findLinkByCodeRef('privacy_policy');
    return link ? `/${link?.locale}${link?.path}` : undefined;
  }, [findLinkByCodeRef, locale, type]);

  return <>{href && <DefaultLink {...rest} href={href} target="_blank" />}</>;
};
